module.exports = __webpack_public_path__ + "img/contactus_w_img@2x.72d08a22.png";